import {formatLength} from './units.js';

/** Read-only display of the original check, separate from any current endpoint
 * bindings used to keep its outer corners attached through a reviewed split. */
export function measurementCheckEvidenceRows(item,doc){
  const check=item.checkReferences;if(!check)return[];
  const rows=[['Originally recorded floor',check.recordedFloorID]];
  for(const [key,name]of[['a','A'],['b','B']]){
    const ref=check[key],p=check[key==='a'?'recordedA':'recordedB'];
    rows.push([`Original corner ${name} identity`,`${ref.wallId} · endpoint ${ref.end.toUpperCase()}`],
      [`Original corner ${name} coordinates`,`X ${formatLength(p.x,doc,3)} · Y ${formatLength(p.y,doc,3)}`]);
  }
  return rows;
}
